// extracted by mini-css-extract-plugin
module.exports = {"loadOuter":"GeneralStatisticsOneForm_loadOuter__JCr7G","select":"GeneralStatisticsOneForm_select__1G7ab"};